function optimizeInlineCss(cssString) {
  const commentRegex = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
  const emptyLineRegex = /^\s*[\r\n]/gm;

  return cssString.replace(commentRegex, '').replace(emptyLineRegex, '');
}

export default optimizeInlineCss;
